/*
 * @Author: ken yang
 * @Date: 2022-10-31 18:03:49
 * @LastEditTime: 2023-08-30 18:25:55
 * @LastEditors: ken yang
 * @Description:
 * @FilePath: /uexch_h5/src/utils/request/index.js
 */
import axios from 'axios'
import useFixTime from './fixTime'
import useDelNullKey from './delNullKey'
import DiaOverlayJs from '../../components/widget/DiaOverlay'
// development
const baseURL = serveUrl
const instance = axios.create({
  baseURL: baseURL,
  timeout: 1000 * 60 * 5,
})

const okCode = 1
const warnCode = -1
const needLoginCode = 50
const upgradeCode = 700

const deviceType2Url = [
  '/user/banners'
]

// 不需要弹报错的code
const noTipsCode = [18040, 18111]

const isNeedLoginRequest = (url) => needLoginUrl.includes(url)

let canAlertLogoutError = true
const alertLogoutError = (message, cooldownMs = 3000) => {
  if (!canAlertLogoutError) {
    return
  }
  DiaOverlayJs({ message })
  canAlertLogoutError = false
  setTimeout(() => {
    canAlertLogoutError = true
  }, cooldownMs)
}

useFixTime(instance)
useDelNullKey(instance)

// 添加请求拦截器
instance.interceptors.request.use(async (config) => {
  const userStore = useUserStore()
  const languageStore = useLanguageStore()
  const time = +new Date()

  if (config.auth !== false && isNeedLoginRequest(config.url) && isEmpty(userStore.token)) {
    return Promise.reject({
      code: needLoginCode,
      config,
      __needLoginBlocked: true,
    })
  }

  config.headers.time = time
  config.headers.deviceType = 3
  const obj = fixTime(delNullKey(config.data || {}), '/')
  config.headers.signature = encrypt.requestSign(obj, time)
  config.headers.language = languageStore.locale

  if (deviceType2Url.includes(config.url)) {
    config.headers.deviceType = 2
  }

  if (config.auth === false) {
    delete config.headers.token
  } else {
    if (userStore.token) {
      config.headers.token = userStore.token
    } else {
      delete config.headers.token
    }
  }
  return config
})

// 白名单报错
const errorDia = (data) => {
  if (!noTipsCode.includes(data.code)) {
    DiaOverlayJs({ message: data.message })
  }
}

// 登出相关报错（防重复）
const logoutErrorDia = (data) => {
  if (!noTipsCode.includes(data.code)) {
    alertLogoutError(data.message)
  }
}

instance.interceptors.response.use(
  (res) => {
    const userStore = useUserStore()
    const { config, data } = res
    const okCodes = Array.isArray(config.okCodes) ? config.okCodes : [okCode]

    if (data.code == needLoginCode) {
      logoutErrorDia(data)
      userStore.logout()
      return Promise.reject(data)
    } else if (data.code === upgradeCode) {
      router.push('/upgrade')
      return Promise.reject(data)
    } else if (data.code === warnCode) {
      DiaOverlayJs({ message: data.message })
    } else if (!okCodes.includes(data.code)) {
      errorDia(data)
      return Promise.reject(data)
    }
    return res
  },
  async (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    }
    if (error?.__needLoginBlocked) {
      return Promise.reject(new Error('该接口需要登录后才能访问'))
    }
    const response = error?.response
    const httpCode = response?.status
    if (httpCode != 200) {
      DiaOverlayJs({ message: $t('public.networkError') })
      return Promise.reject($t('public.networkError'))
    }

    return Promise.reject(error)
  }
)

export default instance
